import * as yup from "yup";
import {string} from "yup";
import i18n from "../../../AppSystem/i18n";

class AdminRequestRoleUserModel {
    constructor({
                    role = '',
                    orgType = '',
                    permissions = [],
                } = {}) {
        this.role = role;
        this.orgType = orgType;
        this.permissions = permissions;
    }

    static getAttributes(filter = null, validationSchema = null, optionsData = null) {

        const completeSchema = yup.object().shape({
            role: string().required(i18n.t('validationMessage.fieldRequired')),
            //permissions: string().required('Field required'),
        });

        const attributes = {
            role :{
                'label': i18n.t('role.role'),
                'form': {
                    'type': 'text',
                    'inputType': 'inline',
                    'placeholder': i18n.t('formPlaceholder.enterRole'),
                    'validation': completeSchema.fields.role,
                },
                'value': (item) => item.role || "",
            },
            // permissions :{
            //     'label': 'Permissions',
            //     'form': {
            //         'type': 'text',
            //         'inputType': 'inline',
            //         'placeholder': 'Enter permission',
            //         'validation': completeSchema.Fields.permissions,
            //     },
            //     'value': (item) => item.permissions || "",
            // },

        }

        if (validationSchema === true) {
            return completeSchema;
        }
        return attributes;
    }
}
export default AdminRequestRoleUserModel;